import React, { Component } from 'react';

import { Card, Grid } from '@material-ui/core';
import { KeyboardArrowRight} from '@material-ui/icons';

// Actions
import { T } from 'Actions/translate';

class F1OrderCard extends Component {

    state = {

	}

  render() {
    const { orderDetails, type } = this.props;

    return (
	    <Card className='f1-order-card' onClick={ this.props.chooseOrder.bind(this, orderDetails) }>
	      	<Grid className='f1-order-container' container spacing={0}>

				<Grid className='left-content-grid' item xs={11}>

					<Grid className='f1-order-detials-container' container spacing={0}>
			  			<Grid className='supply-center-title-grid' item xs={12}>
			  				<span>{orderDetails.supplyCenterName}</span>
			  			</Grid>

				    	<Grid className='f1-order-content-grid' item xs={12}>
				  			<Grid className='f1-order-details-container' container spacing={0}>
				  				<Grid item xs={12}>
					      			{T('fone_order_number_colon')}<span>{orderDetails.number}</span>
					      		</Grid>
                                <Grid item xs={12}>
                                    {T('fone_order_eone_number_colon')}<span>{ orderDetails.eoneNumber }</span>
                                </Grid>
                                <Grid item xs={12}>
                                    {T('fone_order_eone_status')}<span>{ T(orderDetails.eoneStatus) }</span>
                                </Grid>
					      		{ type === 1 ? 	<Grid item xs={12}>
									      			{T('fone_order_receive_date')}<span>{orderDetails.receivedTime}</span>
									      		</Grid> :
												<Grid item xs={12}>
									      			{T('fone_order_replenishment_date')}<span>{orderDetails.createTime}</span>
									      		</Grid>
					      		}
					      		{ type === 1 ? 	<Grid item xs={12}>
									      			{T('fone_order_receive_amount')}<span>{orderDetails.receivedQuantity}</span>
									      		</Grid> :
												<Grid item xs={12}>
									      			{T('fone_order_replenishment_amount')}<span>{orderDetails.totalQuantity}</span>
									      		</Grid>
					      		}
				  			</Grid>
				  		</Grid>
			    	</Grid>
			    </Grid>

		    	<Grid className='right-content-grid' item xs={1}>
		  			<KeyboardArrowRight/>
		    	</Grid>

	    	</Grid>
	    </Card>
	    )
	}
}


export default F1OrderCard
